var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"merchant-identity",class:[`merchant-identity--${_vm.variant}`],style:(_vm.containerStyle),attrs:{"tabindex":"-1"}},[(_vm.resolvedHasLogo)?[_c('img',{attrs:{"src":_vm.resolvedLogo,"alt":"","tabindex":"-1"}})]:(_vm.showTextFallback)?[_vm._v("\n        "+_vm._s(_vm.merchantTextLogo)+"\n    ")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }